import { useSelector } from 'react-redux';
import { selectUser } from '../store/userSlice';
import { RoleName } from '../shared-components/Types/Role';

export const useRoleCheck = (requiredRoles: readonly RoleName[]) => {
  const user = useSelector(selectUser);

  return requiredRoles.some((role) => user.role?.name === role);
};
